import { capitalize } from '@ember/string';
import DiscoveryPrimaryBadge from 'ember-simplepractice/components/spds/indicator/badge/discovery/primary';
import DiscoverySecondaryBadge from 'ember-simplepractice/components/spds/indicator/badge/discovery/secondary';
import InfoSecondaryBadge from 'ember-simplepractice/components/spds/indicator/badge/info/secondary';
import NegativeSecondaryBadge from 'ember-simplepractice/components/spds/indicator/badge/negative/secondary';
import WarningSecondaryBadge from 'ember-simplepractice/components/spds/indicator/badge/warning/secondary';

export const ALL = 'all';
export const BREAKING = 'breaking';
export const CLEANUP = 'cleanup';
export const ENHANCEMENT = 'enhancement';
export const FEATURE = 'feature';
export const FIX = 'fix';

export const TYPE_BADGES = Object.freeze({
  [BREAKING]: NegativeSecondaryBadge,
  [CLEANUP]: InfoSecondaryBadge,
  [ENHANCEMENT]: DiscoverySecondaryBadge,
  [FEATURE]: DiscoveryPrimaryBadge,
  [FIX]: WarningSecondaryBadge,
});

export const TYPE_LABELS = Object.freeze({
  [FEATURE]: capitalize(FEATURE),
  [CLEANUP]: capitalize(CLEANUP),
  [ENHANCEMENT]: capitalize(ENHANCEMENT),
  [BREAKING]: capitalize(BREAKING),
  [FIX]: capitalize(FIX),
});

export default {
  ALL,
  BREAKING,
  CLEANUP,
  ENHANCEMENT,
  FEATURE,
  FIX,
  TYPE_BADGES,
  TYPE_LABELS,
};
